import { ToolPageShell } from '@/shared/seo'
import { IzvlechKartinkiIzPdfForm } from './IzvlechKartinkiIzPdfForm'

export function IzvlechKartinkiIzPdfPage() {
  return (
    <ToolPageShell utilityKey="extract-images-from-pdf">
      <IzvlechKartinkiIzPdfForm />
    </ToolPageShell>
  )
}
